/**
 * vkRetargeting
 */
export const vkRetargeting = (window.VK && window.VK.Retargeting) || {}
